// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1219":"67d4e80374488fe4","1324":"8cf3851502fe25a6","5833":"37ad696dd57211cf","9175":"3393f19c0f4b1775"}[chunkId] + ".js";
};